export default __webpack_public_path__ + "static/media/arrow-right-v2.7735aabf.svg";